import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { Observable } from "rxjs";
import { CalcExchangeRequestViewModel } from "../../../model/src/lib/calcExchangeRequestViewModel";
import { CalcExchangeResponseViewModel } from "../../../model/src/lib/calcExchangeResponseViewModel";
import { CalcTaxRequestViewModel } from "../../../model/src/lib/calcTaxRequestViewModel";
import { CalcTaxResponseViewModel } from "../../../model/src/lib/calcTaxResponseViewModel";
import { DropdownOption } from '../../../model/src/lib/dropdown-option.model';
import { AppConfig } from "../../config/app.config";
import { ApiBaseService } from "./api-base.service";


/**
 * 共用功能服務 API 服務
 *
 * @export
 * @class ApiCommonService
 * @extends {ApiBaseService}
 */
@Injectable({
  providedIn: 'root',
})
export class ApiCommonService extends ApiBaseService {

  constructor(
    protected appConfig: AppConfig,
    protected http: HttpClient,
    private logger: NGXLogger) {
    super(appConfig.getApiUrl('common'), http);
  }

  /**
   * 取得下拉選單
   *
   * @param {string} type
   * @param {string} code
   * @return {*}  {Observable<DropdownOption[]>}
   * @memberof ApiCommonService
   */
  getDropdownList(type?: string, code?: string): Observable<DropdownOption[]> {
    const url = `${this.baseUrl}/DropDownList`;
    let queryParameters = new HttpParams();
    if (code !== undefined && code !== null) {
      queryParameters = queryParameters.set('code', <any>code);
    }
    if (type !== undefined && type !== null) {
      queryParameters = queryParameters.set('type', <any>type);
    }
    return this.http.get<DropdownOption[]>(url, { params: queryParameters });
  }

  /**
   * @description 依地址代碼取得郵遞區號
   * @returns 郵遞區號列表
   */
   addressAddressCodePostcodesGet(addressCode: string): Observable<string[]> {
    const url = `${this.baseUrl}/Address/${encodeURIComponent(String(addressCode))}/Postcodes`;
    return this.http.get<string[]>(url);
  }


  /**
   * 匯率計算
   *
   * @param {CalcExchangeRequestViewModel} params
   * @return {*}  {Observable<CalcExchangeResponseViewModel>}
   * @memberof ApiCommonService
   */
  exchangeCalcPost(params: CalcExchangeRequestViewModel): Observable<CalcExchangeResponseViewModel> {
    const url = `${this.baseUrl}/Exchange/Calc`;
    return this.doPost<CalcExchangeResponseViewModel>('/Exchange/Calc', params);
  }


  /**
   * 稅率計算
   *
   * @param {CalcTaxRequestViewModel} params
   * @return {*}  {Observable<CalcTaxResponseViewModel>}
   * @memberof ApiCommonService
   */
  taxCalcPost(params: CalcTaxRequestViewModel): Observable<CalcTaxResponseViewModel> {
    const url = `${this.baseUrl}/Tax/Calc`;
    return this.doPost<CalcTaxResponseViewModel>('/Tax/Calc', params);
  }
}
